import { useEffect } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { captureException } from '@sentry/nextjs';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import {
  useUpdateCoachDetailsMutation,
  useUpdateCoachSocialsMutation,
} from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';
import CloseIcon from 'svg/CloseIcon';
import Button, { ButtonText } from 'components/Button';
import InputField from 'components/coaches-builder/InputField';
import { InputType } from 'components/coaches-builder/InputField/InputField';
import ProfileItem from 'components/coaches-builder/ProfileItem';
import Modal from 'components/modals/Modal';
import { lessonsLikeSchema } from './schemas';
import { FormModalModeEnum, FormModalProps } from '../types';

interface LessonsLikeFormModalProps extends FormModalProps {}

type LessosLikeSchemaType = z.infer<typeof lessonsLikeSchema>;

const LessonsLikeFormModal: React.FC<LessonsLikeFormModalProps> = ({
  isOpen,
  handleClose,
  coachData,
  mode,
}) => {
  const {
    register,
    setValue,
    formState: { errors },
    reset,
    handleSubmit,
  } = useForm<LessosLikeSchemaType>({
    resolver: zodResolver(lessonsLikeSchema),
  });

  const [updateCoachDetails, { loading: updateCoachDetailsLoading }] =
    useUpdateCoachDetailsMutation();

  const viewer = useViewer();

  const onSubmit = async (data: LessosLikeSchemaType) => {
    try {
      await updateCoachDetails({
        variables: {
          coachLessonDescription: data.coachLessonDescription,
          userId: viewer.userId,
        },
      });
      handleClose(true);
    } catch (err) {
      captureException(err);
    }
  };

  useEffect(() => {
    // if (mode === FormModalModeEnum.Add) {
    //   reset();
    //   return;
    // }
    if (!coachData) {
      return;
    }
    setValue('coachLessonDescription', coachData?.coachLessonDescription || '');
  }, [coachData, reset, setValue, mode]);

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} classNameMaxWidth="max-w-[80vw]">
      <div className="flex items-center justify-between border-b px-8 py-4">
        <h2 className="typography-product-heading-desktop">What my lessons are like</h2>
        <ButtonText onClick={() => handleClose()}>
          <CloseIcon className="h-4 w-4" />
        </ButtonText>
      </div>
      <div className="flex flex-col px-4 md:px-10">
        <ProfileItem
          label="Description"
          description="Introduce yourself and explain how you get into coaching."
          hasBottomBorder={false}
          component={
            <InputField
              fieldLabel=""
              errors={errors}
              placeholder="Tell more about your lessons"
              name="coachLessonDescription"
              register={register}
              inputType={InputType.Textarea}
            />
          }
        />
      </div>
      <div className="flex justify-end border-t px-8 py-4">
        <Button
          variant="primary"
          disabled={updateCoachDetailsLoading}
          onClick={handleSubmit(onSubmit)}
          className="w-fit"
          size="lg"
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default LessonsLikeFormModal;
